import { React, PT, fetchApi } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Modal, Button, Dimmer, Loader, Icon } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export class TxDetailModal extends React.Component {
  state = {}

  loadAndGo = () => {
    const { transactionId, accountId } = this.props;
    this.setState({ opened: true, loading: true, copied: false }, async () => {
      const { body } = await fetchApi({
        url: '/payments/transaction-status',
        body: { transaction_id: transactionId, account_id: accountId },
      });
      this.setState({ loading: false, body });
    });
  }

  render() {
    const { opened, loading, body, copied } = this.state;
    return (
      <Modal
        closeIcon
        closeOnEscape
        open={opened}
        trigger={<Button floated="right" size="mini" onClick={this.loadAndGo}>View Raw Status</Button>}
      >
        <Modal.Header>
          Transaction Status
        </Modal.Header>
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <JSONTree data={body} shouldExpandNode={(k, d, l) => l <= 1} />
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <CopyToClipboard
            text={JSON.stringify(body, null, 2)}
            onCopy={() => this.setState({ copied: true })}
            options={{ format: 'text/plain' }}
          >
            <Button toggle icon active={copied} labelPosition="left">
              <Icon name={copied ? 'clipboard check' : 'clipboard'} />
              {copied ? 'JSON copied to clipboard!' : 'Copy JSON'}
            </Button>
          </CopyToClipboard>

          <Button basic onClick={() => this.setState({ opened: false, body: null })}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

TxDetailModal.propTypes = {
  transactionId: PT.number,
  accountId: PT.number,
};

TxDetailModal.defaultProps = {
  transactionId: 0,
  accountId: 0,
};
